import React = require('react');
import { Col, Row } from 'react-bootstrap';

export const renderDirectoryDetails = (isDecline: boolean) => {
  return (
    <div className="directory-details">
      <Row>
        <Col xs={12}>
          <div style={{ marginTop: '15px' }}><strong>The MoneyHelper directory</strong></div>
          <div style={{ marginTop: '15px' }}>If you would like to access this directory just visit:</div>
          <div>
            <ul>
              <li>
                Website: <a target={'_blank'}
                            href={'https://www.moneyhelper.org.uk/en/everyday-money/insurance/use-our-travel-insurance-directory'}>
                https://www.moneyhelper.org.uk/en/everyday-money/insurance/use-our-travel-insurance-directory
              </a>
              </li>
              <li>
                Telephone: 0800 138 7777
              </li>
              <li>
                Opening hours: Monday to Friday 8am to 6pm
              </li>
            </ul>
            <div style={{ marginBottom: '15px' }}>
              To request the directory details in writing, please click <a target={'_blank'} href={isDecline ? 'https://eforms.admiral.com/travel-medical-decline' : 'https://eforms.admiral.com/travel-medical-load'}>here</a>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
